<template>
  <StepField />
</template>

<script>
import StepField from '@/components/StepField';

export default {
  components: {
    StepField
  },
  computed: {},
  data: () => ({}),
  methods: {}
};
</script>

<style></style>
